import { AnalyticsManager } from "@repo/analytics";
import { FirebaseWebProvider } from "../analytics/FirebaseWebProvider";

/** Set per env file: `VITE_ENABLE_ANALYTICS` (production: true, lower envs: false). */
const isEnabled = import.meta.env.VITE_ENABLE_ANALYTICS === "true";
const debugMode =
  import.meta.env.DEV ||
  import.meta.env.VITE_DEBUG_ANALYTICS === "true" ||
  true; // Set to true for verification as requested

export const analyticsManager = new AnalyticsManager({
  isEnabled,
  debugMode,
});

AnalyticsManager.setInstance(analyticsManager);

export const initAnalytics = async () => {
  const firebaseProvider = new FirebaseWebProvider();
  await firebaseProvider.init();
  analyticsManager.registerProvider(firebaseProvider);

  // Set initial global properties
  analyticsManager.setGlobalProperties({
    platform: "web",
    environment: import.meta.env.MODE,
  });
};
